class Works {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('table[style*="border-style: solid"]').each(function() {
      $(this).wrap('<div class="js-table"></div>');
    });
  }
}